<template>
	<div style=" overflow-y: auto; overflow-x: hidden">
		<Row :gutter="10" style="margin-bottom: 20px">

			<Col>
			<Form :label-width="80">
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod" @on-change="changeDate">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="条件">
					<Select v-model="cidType" style="width:150px;" clearable placeholder="类型">
						<Option :value="1">投放</Option>
						<Option :value="2">引流</Option>
						<Option :value="-1">重复</Option>
					</Select>
					<Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</Button>
					<Button @click="initSearch" style="margin-left: 10px;">重置</Button>
				</FormItem>
			</Form>
			</Col>
		</Row>
		<Table border :columns="columns" :data="profitsData">
			<template slot-scope="{ index,row }" slot="lirun_last0">
				<span v-if="row.lirun_last1 < row.lirun_last0"
					style="color:#ff0000;cursor: pointer;">{{row.lirun_last0}}<br>
					<Icon type="md-arrow-round-up" style="color: red;" />{{row.growth_rate1}}
				</span>
				<span v-else-if="row.lirun_last1 >= row.lirun_last0"
					style="color:#ffaa7f;cursor: pointer;">{{row.lirun_last0}}<br>
					<Icon type="md-arrow-round-down" style="color:#ffaa7f;" />{{row.growth_rate1}}
				</span>
			</template>
			<template slot-scope="{ row, index }" slot="quotation_money_last0">
				<div style="color: #2d8cf0;">
					<span>{{row.quotation_money_last0}}</span>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="form_nums_last0">
				<div style="color: #2d8cf0;">
					<span>{{row.form_nums_last0}}</span>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="adv_average_money_last0">
				<div style="color: #2d8cf0;">
					<span>{{row.adv_average_money_last0}}</span>
				</div>
			</template>
			<template slot-scope="{ row, index }" slot="quotion_avg_last0">
				<div style="color: #2d8cf0;">
					<span>{{row.quotion_avg_last0}}</span>
				</div>
			</template>
		</Table>
	</div>
</template>

<script>
	import {
		getDowmstreamProfitsList
	} from "../../api/runSet";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "downstreamAnalysis",
		data() {
			return {
				timePeriod: '5',
				cidType: '',
				timePeriodDate: [],
				columns: [{
						title: "排名",
						type: "index",
						align: 'center',
						width: '100px'
					},
					{
						title: "渠道",
						key: "username",
						align: 'center'
					},
					{
						title: "城市",
						key: "city",
						align: 'center'
					},
					{
						title: "利润",
						key: "earn_money",
						align: 'center'
					},
					{
						title: "上期利润",
						key: "last_earn_money",
						align: 'center'
					},
					{
						title: "平均报价",
						key: "quotion_avg",
						align: 'center'
					},
					{
						title: "上期平均报价",
						key: "last_quotion_avg",
						align: 'center'
					},
					{
						title: "数量",
						key: "form_nums",
						align: 'center'
					},
					{
						title: "上期数量",
						key: "last_form_nums",
						align: 'center'
					},
					{
						title: "投放成本",
						key: "adv_avg",
						align: 'center'
					},
					{
						title: "上期投放成本",
						key: "last_adv_avg",
						align: 'center'
					},
				],
				profitsData: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				console.log(this.timePeriodDate)
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.timePeriod = that.timePeriod
				data.timePeriodDate = that.timePeriodDate
				data.cidType = that.cidType;
				data.order_type = that.order_type;
				let res = await getDowmstreamProfitsList(that, data);
				that.profitsData = res.data.list;
			},
		},
	};
</script>

<style lang="less" scoped>
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>